module.exports = __webpack_public_path__ + "media/images/arrows/down-orange-b60e853540fd14dfd887e6d82e712b2a.svg";